import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/io+sp.png'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { style: {"margin":"20vh 0 0 -45px","text-align":"center"} }, [
  /*#__PURE__*/_createVNode("img", {
    style: {"width":"55%"},
    src: _imports_0,
    alt: "logo"
  })
], -1)
const _hoisted_2 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Renew subscription ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Cancel subscription ")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Renew subscription ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Cancel subscription ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.hubIsShopify)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (!_ctx.connectHubSP.charge_id)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                style: {"margin-top":"20px","margin-right":"20px"},
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doRenew(_ctx.connectHubSP.connections[0])))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                style: {"margin-top":"20px","margin-left":"20px"},
                type: "danger",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doCancel(_ctx.connectHubSP.connections[0])))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }))
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_el_table, { data: _ctx.listConnectSPTarget }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, { label: "Name" }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.connection.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "Price",
                width: "240"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode("$" + _toDisplayString(scope.row.price), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "Inspect",
                width: "450"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (_ctx.doRenew(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_button, {
                    type: "danger",
                    size: "small",
                    onClick: ($event: any) => (_ctx.doCancel(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]))
  ], 64))
}